
export default {
  components: {},
  props: {
    shipTimeInfo: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {}
  },
  methods: {}
}
